<template>
  <form @submit.prevent="sendNewMessage">
    <b-form-group class="mb-3" v-if="!noSubject">
      <label for="subject" v-translate>Subject</label>
      <b-form-input id="subject" v-model="subject" />
    </b-form-group>
    <b-form-group class="mb-3">
      <label for="message" v-translate>Message <small class="text-danger">(*)</small></label>
      <b-form-textarea
        id="message"
        :placeholder="$gettext('Type your message here...')"
        rows="5"
        max-rows="20"
        v-model="message"
        required
      ></b-form-textarea>
    </b-form-group>
    <generic-picture-upload minimal @updated="filesUpdated" />
    <b-form-group class="text-center form-actions">
      <b-button type="submit" variant="primary" size="lg" v-translate>Send Message</b-button>
      <b-button type="button" variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Cancel</b-button>
    </b-form-group>
  </form>
</template>

<script>
import GenericPictureUpload from '@/components/GenericPictureUpload'

export default {
  name: 'ShippingMessageThreadForm',
  components: {
    GenericPictureUpload
  },
  props: {
    type: {
      type: String,
      default: 'internal'
    },
    shippingId: {
      type: String,
      required: true
    },
    noSubject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subject: '',
      message: '',
      files: []
    }
  },
  methods: {
    sendNewMessage() {
      if (this.files.length > 0) {
        this.message += '<hr>'
        this.message += '<div class="mssg-img-wrapper">'
        for (const file of this.files) {
          this.message += '<a href="' + file.response.full_path + '" target="_blank" class="mssg-img-link"><img src="' + file.response.full_path + '" class="mr-3 mb-3 mssg-img" /></a>'
        }
        this.message += '</div>'
      }
      let payload = {
        subject: this.subject || this.message.replace(/\n/g, ' ').replace(/^(.{40}[^\s]*).*/, '$1') + '...',
        message: this.message,
        type: this.type
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + this.shippingId + '/messages', payload)
        .then(response => {
          this.emitSuccess()
        })
    },
    filesUpdated(e) {
      this.files = e
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    emitCancel() {
      this.$emit('cancel', true)
    }
  }
}
</script>
